export const isBoldActive = isActive('strong');
export const isItalicActive = isActive('em');
export const isH1Active = isActive('header-1');
export const isH2Active = isActive('header-2');
export const isH3Active = isActive('header-3');
export const isH4Active = isActive('header-4');
export const isH5Active = isActive('header-5');
export const isH6Active = isActive('header-6');
function isActive(type) {
    return (cm) => {
        var _a;
        const token = (_a = cm.getTokenTypeAt(cm.getCursor('start'))) !== null && _a !== void 0 ? _a : '';
        return token.split(' ').includes(type);
    };
}
